export default {
  methods: {
  	command_list(cmd,enter){
        let self = this;
        let cmds=[
            {cmd:'store',todo:function(){
            	if(self.vip_info.mobile){
            		return  self.msgpad_show("msgpad", "ERROR", '查询仓库库存<br>请先清除会员信息！', 'error');
            	}
                self.$store.dispatch('act_lookup_home_stock',{ 
                      gid:"",name:"",
                      prepare:!enter,
                      self,
                      callback :(data,tab="tab-prepare")=>{
                        self.act_tab(tab);
                        self.clear_input()
                      }
                })
            }},
            {cmd:'clear',todo:function(){
                if(enter){
                    self.confirm_dlg("确定要重置系统？").then(_=>{
                        self.$store.commit('MUTATIONS_SHOP_SHOP_INFO',null);
                        self.$router.push('/login')
                    }).catch(_=>{
                        self.clear_input()
                    })
                }
            }}
        ]
        let cmd_def = cmds.find(it=>it.cmd == cmd);
        if(cmd_def) {
            cmd_def.todo();
            return true;
        }
        return false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/front_sale/mixin/mix_commands.js